import { useEffect, useState } from 'react';
import api from '../utils/axiosConfig';

export function useAccountDeletionAvailability() {
    const [available, setAvailable] = useState(null);
    useEffect(() => {
        let active = true;
        api.get('/api/account/deletion/availability', { headers: { Authorization: '' } })
            .then(({ data }) => { if (active) setAvailable(data.available === true); })
            .catch(() => { if (active) setAvailable(false); });
        return () => { active = false; };
    }, []);
    return available;
}
